module.exports = __webpack_public_path__ + "img/scope3category4.98c60714.svg";